@if (!disabled) {
  <div class="datetime-container">
    <app-template-date [control]="group.controls.date" [value]="dateValue" [required]="required" [characters]="characters" />
    <app-template-time [control]="group.controls.time" [value]="timeValue" [required]="required" [characters]="characters" />
  </div>
} @else {
  <app-template-html [control]="control" [label]="label" [value]="value" />
}
